export const GET_RESOURCE_CATEGORIES = 'GET_RESOURCE_CATEGORIES'
export const GET_BOARD_RESOURCES = 'GET_BOARD_RESOURCES'
export const CHANGE_BOARD_RESOURCE = 'CHANGE_BOARD_RESOURCE'
export const GET_BOARD_RESOURCES_SCHEMA = 'GET_BOARD_RESOURCES_SCHEMA'
export const GET_BOARD_TASK_MAIN_RESOURCES = 'GET_BOARD_TASK_MAIN_RESOURCES'
export const GET_TASK_RESOURCES = 'GET_TASK_RESOURCES'
export const GET_TASKMAP_RESOURCES = 'GET_TASKMAP_RESOURCES'
export const GET_RESOURCES_REPORTS = 'GET_RESOURCES_REPORTS'
export const ADD_RESOURCES_REPORT = 'ADD_RESOURCES_REPORT'
export const GET_RESOURCES_BUYLISTS = 'GET_RESOURCES_BUYLISTS'
export const GET_RESOURCES_BUYLIST = 'GET_RESOURCES_BUYLIST'
export const GET_TASKMAP_RESOURCES_BUYLIST = 'GET_TASKMAP_RESOURCES_BUYLIST'
export const GET_TASK_RESOURCES_BUYLIST = 'GET_TASK_RESOURCES_BUYLIST'
export const ADD_RESOURCES_BUYLIST = 'ADD_RESOURCES_BUYLIST'
export const DELETE_RESOURCES_BUYLIST = 'DELETE_RESOURCES_BUYLIST'
export const GET_RESOURCE_TYPES = 'GET_RESOURCE_TYPES'
export const CHANGE_TASKMAP_RESOURCE = 'CHANGE_TASKMAP_RESOURCE'
